import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';

const initialState = {
  altAssetResolutionAssetTypes: getInitialState.list(),
  altAssetResolutionTypes: getInitialState.list(),
  assetTypes: getInitialState.list(),
  auditAssignmentStatus: getInitialState.list(), 
  auditStatus: getInitialState.list(),
  categories: getInitialState.list(),
  exclusionReasonTypes: getInitialState.list(),
  fileGroups: getInitialState.list(),
  fileMappings: getInitialState.list(),
  fileTypes: getInitialState.list(),
  groups: getInitialState.list(),
  groupAuditStatus: getInitialState.list(),
  identifiers: getInitialState.list(),
  imageTypes: getInitialState.list(),
  makes: getInitialState.list(),
  makeTypes: getInitialState.list(),
  organisationAssetTypes: getInitialState.list(),
  organisationTypes: getInitialState.list(),
  services: getInitialState.list(),
  rejectionReasons: getInitialState.list(),
  resolutionReasons: getInitialState.list(),
  typeAttributes: getInitialState.list(),
  typeIdentifiers: getInitialState.list(),
  uploadStatus: getInitialState.list(),
  validationFields: getInitialState.list(),
  validationRules: getInitialState.list(),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.TYPES_LIST_GET_REQUEST: {
      return initialState;
    }
    case actionTypes.TYPES_LIST_GET_SUCCESS: {
      const { typesList } = action.payload;
      return typesList;
    }
    
    default: {
      return state;
    }
  }
}
